import { render, staticRenderFns } from "./SuppliersList.vue?vue&type=template&id=c8737bf4&scoped=true&"
import script from "./SuppliersList.vue?vue&type=script&lang=js&"
export * from "./SuppliersList.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersList.vue?vue&type=style&index=0&id=c8737bf4&scoped=true&lang=css&"
import style1 from "./SuppliersList.vue?vue&type=style&index=1&id=c8737bf4&lang=scss&scoped=true&"
import style2 from "./SuppliersList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8737bf4",
  null
  
)

export default component.exports